/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PluginMappingChangeResponse } from './PluginMappingChangeResponse';
import {
    PluginMappingChangeResponseFromJSON,
    PluginMappingChangeResponseFromJSONTyped,
    PluginMappingChangeResponseToJSON,
} from './PluginMappingChangeResponse';

/**
 * A plugin mapping's change history, newest first
 * @export
 * @interface PluginMappingChangeListResponse
 */
export interface PluginMappingChangeListResponse {
    /**
     * 
     * @type {Array<PluginMappingChangeResponse>}
     * @memberof PluginMappingChangeListResponse
     */
    items: Array<PluginMappingChangeResponse>;
}

/**
 * Check if a given object implements the PluginMappingChangeListResponse interface.
 */
export function instanceOfPluginMappingChangeListResponse(value: object): value is PluginMappingChangeListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PluginMappingChangeListResponseFromJSON(json: any): PluginMappingChangeListResponse {
    return PluginMappingChangeListResponseFromJSONTyped(json, false);
}

export function PluginMappingChangeListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginMappingChangeListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PluginMappingChangeResponseFromJSON)),
    };
}

export function PluginMappingChangeListResponseToJSON(value?: PluginMappingChangeListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(PluginMappingChangeResponseToJSON)),
    };
}

